import { Component, EventEmitter, inject, InjectFlags, Input, OnInit, Output } from '@angular/core';
import { DataApiResponse, UserSkillModel } from '@digilize/shared/definitions/src';

import { SkillsService } from '../../../services/skills.service';
import { WizardService } from '../../../services/wizard.service';

export const CV_PARSED_SKILL_IDS_KEY = 'cv_parsed_skill_ids';

@Component({
  selector: 'bwc-cv-skills',
  templateUrl: './cv-skills.component.html',
  styleUrls: ['./cv-skills.component.scss'],
})
export class CvSkillsComponent implements OnInit {
  @Input() prevBut: boolean;
  @Input() closeBut: boolean;
  @Output() emitClose = new EventEmitter();

  wizardService = inject(WizardService, InjectFlags.Optional);

  skills: UserSkillModel[] = [];
  dataLoaded = false;

  constructor(private skillsService: SkillsService) {}

  ngOnInit(): void {
    const storedIds = this.getStoredSkillIds();
    if (!storedIds.length) {
      this.dataLoaded = true;
      this.autoSkip();
      return;
    }

    this.skillsService.getAllUserSkills().subscribe((resp: DataApiResponse<UserSkillModel[]>) => {
      const idSet = new Set(storedIds);
      this.skills = (resp.data ?? []).filter((s) => idSet.has(s.id));
      this.dataLoaded = true;

      if (!this.skills.length) {
        this.autoSkip();
      }
    });
  }

  private autoSkip(): void {
    if (this.wizardService?.lastDirection === 'back') {
      this.wizardService.goToPrevious();
    } else {
      this.wizardService?.goToNext();
    }
  }

  removeSkill(index: number): void {
    const skill = this.skills[index];
    if (!skill) return;

    this.skillsService.deleteUserSkill(skill.id).subscribe(() => {
      this.skills.splice(index, 1);
      this.removeStoredSkillId(skill.id);
    });
  }

  nextStep(): void {
    this.wizardService?.goToNext();
  }

  goPrev(): void {
    this.wizardService?.goToPrevious();
  }

  close(): void {
    this.emitClose.emit('cv_skills');
  }

  private getStoredSkillIds(): string[] {
    try {
      const raw = sessionStorage.getItem(CV_PARSED_SKILL_IDS_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  private removeStoredSkillId(id: string): void {
    const ids = this.getStoredSkillIds().filter((storedId) => storedId !== id);
    sessionStorage.setItem(CV_PARSED_SKILL_IDS_KEY, JSON.stringify(ids));
  }

  static saveParsedSkillIds(ids: string[]): void {
    sessionStorage.setItem(CV_PARSED_SKILL_IDS_KEY, JSON.stringify(ids));
  }
}
